import { TabScrollButton, TabScrollButtonProps } from "@mui/material";
import { forwardRef } from "react";

// html tags for test automation
export const NavScrollButton = forwardRef<
  HTMLButtonElement,
  TabScrollButtonProps
>(({ direction, ...props }, ref) => (
  <TabScrollButton
    ref={ref}
    aria-label={`Clicca su freccia per scorrere a ${handleDirection(direction)} le tab della Navigation Bar`}
    role="button"
    direction={direction}
    id={`corporate-detail-tabs-arrow-${direction}"`}
    data-testid={`corporate-detail-tabs-arrow-swipe-${direction}"`}
    {...props}
  />
));

function handleDirection(direction: "left" | "right") {
  if (direction === "left") {
    return "sinistra";
  }

  return "destra";
}
